import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './work-orders-office.scss'

const WorkOrdersOffice = () => {
  const { t } = useTranslation(['work-orders-office'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="work-orders-office">
      <div className="work-orders-office__container">
        <iframe
          src={`https://elevateoshub.com/work-orders?email=${encodeURIComponent(userEmail)}`}
          className="work-orders-office__iframe"
          title={t('work-orders-office:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default WorkOrdersOffice
